"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNullish = void 0;
function isNotNullish(value) {
    // (A)
    return value !== undefined && value !== null;
}
exports.isNotNullish = isNotNullish;
//# sourceMappingURL=type-guards.js.map